enum GenderIdentity {
    Unknown = 0,
    Male,
    Female,
    TransMale,
    TransFemale,
    NonBinary,
    Genderqueer,
    Genderfluid,
    TwoSpirit,
    Agender,
    PrefersNotToSay,
    Other
}

export { GenderIdentity };
